import * as Scrrivito from "scrivito";

// This is just a dummy component so prerender works correctly while in development.
Scrrivito.provideComponent("FavouriteCoursesPage", () => null);
